// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1UxSz","addWidgetButton":"Header_addWidgetButton__2Vw4N","dashboardTabs":"Header_dashboardTabs__1Wk-r","active":"Header_active__2YTJv"};